<template>
  <div class="positioner">
    <arrow-animation
      v-if="showArrows"
      position="bottom"
      style="position: absolute; left: 2%; bottom: 12%; transform-origin: 0 100%; width: 320px; height: 156px;"
    />
    <tutorial-keyboard-keys
      v-if="showArrows"
      type="arrow-keys"
      :text="$t('webInfoLeft') + ' / ' + $t('webInfoRight')"
      is-scaled
      class="keyboard-side-keys"
    >
      <section
        class="tutorial-keyboard-keys-wrapper"
      >
        <tutorial-keyboard-key
          type="arrow"
          rotation="left"
          letter="a"
          glow
        />
        <tutorial-keyboard-key
          type="arrow"
          rotation="right"
          letter="d"
          glow
        />
      </section>
    </tutorial-keyboard-keys>
    <arrow-animation
      v-if="showSpace"
      position="bottom"
      style="position: absolute; right: 2%; bottom: 12%; transform-origin: 100% 100%; width: 310px; height: 146px;"
    />
    <tutorial-keyboard-keys
      v-if="showSpace"
      type="space"
      :text="$t('webInfoStart')"
      class="keyboard-space"
      is-scaled
    >
      <tutorial-keyboard-key
        type="space"
        glow
      />
    </tutorial-keyboard-keys>
  </div>
</template>

<script lang="ts">

import {
  ArrowAnimation,
  TutorialKeyboardKeys,
  TutorialKeyboardKey,
  gameSettingsState
} from '@powerplay/core-minigames-ui'
import {
  modes,
  ControlsTypes
} from '@powerplay/core-minigames'
import { defineComponent } from 'vue'
import { tutorialState } from '@/stores'

export default defineComponent({
  name: 'TutorialKeys',
  components: {
    ArrowAnimation,
    TutorialKeyboardKeys,
    TutorialKeyboardKey
  },
  computed: {
    isControlsTypeAutoTuck(): boolean {

      if (modes.isTutorial()) return true
      return gameSettingsState().controlsType === ControlsTypes.autoTuck ||
        Number(import.meta.env.VITE_APP_AUTOTUCK_FORCED) === 1

    },
    showSpace(): boolean {

      return tutorialState().showButtonStart

    },
    showArrows(): boolean {

      return tutorialState().showButtonsMovement

    }
  }
})

</script>

<style lang="less" scoped>
    .positioner {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 25%;

        .keyboard-side-keys {
            transform-origin: 0 100%;
            position: absolute;
            left: 2%;
            bottom: 10%;

            .tutorial-keyboard-keys-wrapper {
                height: 100px;
            }
        }

        .keyboard-space {
            transform-origin: 100% 100%;
            position: absolute;
            right: 2%;
            bottom: 10%;
        }
    }
</style>
